import React, { useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Button } from "reactstrap";
import { strictWorkstations } from "../../store/actions";

const StrictWorkstation = function (props) {
  let ws = props.ws;
  const [showAlert, setShowAlert] = useState(false);
  let user = JSON.parse(localStorage.getItem("authUser"));

  const strictWorkstations = () => {
    props.strictWorkstations(ws, user.token, props.history);
  };
  const noStrictTasks = () => {
    setShowAlert(false);
  };
  const pressButton = (event) => {
    event.preventDefault();
    setShowAlert(true);
  };

  return (
    <React.Fragment>
      <Button
        className="btn btn-danger waves-effect waves-light buttonStatus wsButton"
        onClick={(event) => pressButton(event)}
      >
        {" "}
        <i className="far fa-hand-rock font-size-16 align-middle mr-2"></i>{" "}
        {props.t("NoStrict")}
      </Button>
      {showAlert && (
        <SweetAlert
          title={props.t("¿Está seguro? ")}
          warning
          showCancel
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          cancelBtnText={props.t("cancel")}
          confirmBtnText={props.t("ok")}
          onConfirm={() => strictWorkstations()}
          onCancel={() => noStrictTasks()}
        >
          {props.t("Vas restringir la prioridad de esta estación de trabajo, ")}
          <br />
          {props.t("no aceptará tareas menos prioritarias")}
        </SweetAlert>
      )}
    </React.Fragment>
  );
};

const mapStateProps = (state) => {
  const { loadingStrictWs } = state.strictWorkstations;

  return { loadingStrictWs };
};

export default withRouter(
  connect(mapStateProps, {
    strictWorkstations,
  })(withNamespaces()(StrictWorkstation))
);
